<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Add Retailer</h4>
            <p v-if="!maxReached" class="category">You can add up to {{ retailerSlotsRemaining }} more retailers on your {{ accountData.authDetails.account.data.planName }} Plan.</p>
          </div>
          <div class="card-content">
            <p v-if="maxReached" class="text-danger">Please upgrade your Authentic.net plan if you wish to add more retailers.</p>
            <form v-if="!maxReached" method="get" action="/" v-on:submit.prevent class="form-horizontal">
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Name</label>
                  <div class="col-sm-10">
                    <input type="text" name="title" v-model="newRetailer.name" v-validate="modelValidations.name" class="form-control" />
                    <small class="text-danger" v-show="name.invalid">
                      {{ getError('name') }}
                    </small>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Logo</label>
                  <div class="col-sm-10">
                    <input type="file" name="imageFile" ref="imageFile" accept="image/*" @change="selectFile" />
                    <input v-show="false" type="text" name="logoUrl" v-model="newRetailer.logoUrl" v-validate="modelValidations.logoUrl"  class="form-control" />
                    <small class="text-danger" v-show="logoUrl.invalid">
                      {{ getError('logoUrl') }}
                    </small>
                    <p-progress :value="uploadProgress" type="info"></p-progress>
                  </div>
                </div>
              </fieldset>

              <button type="submit" v-if="!loading" @click.prevent="validateAddRetailer()" class="btn btn-fill btn-info">Submit</button>
              <button type="button" v-if="loading" class="btn btn-wd btn-info" disabled="disabled">
                <span class="btn-label">
                  <i class="fa fa-circle-o-notch fa-spin"></i>
                </span>
                Submit
              </button>
            </form>
          </div>
        </div>  <!-- end card -->
      </div> <!-- end col-md-12 -->
    </div>
    <div v-show="showingAmazon" class="row">
      <div style="padding: 20px;">
        <button @click.prevent="getRetailers()" class="btn btn-fill btn-info">Back to All Retailers</button>
      </div>
    </div>
    <div class="row">
      <div v-show="!showingAmazon" class="col-lg-3">
        <div class="card" style="padding-top:10px;">
          <div class="text-center">
            <h3>Amazon</h3>
          </div>
          <div class="text-center" style="height: 140px; display: flex; align-items: center;">
            <div class="img-container">
              <img src="https://firebasestorage.googleapis.com/v0/b/authentic-net-dev.appspot.com/o/global-retailers%2Famz%2Famz_140x140.png?alt=media&token=90d16dd3-61f2-4e5c-a2f9-c2c418b5ad39" alt="Amazon">
            </div>
          </div>
          <hr>
          <div class="text-center" style="height: 40px;">
            <button type="button" @click.prevent="getGloAmazonRetailers()" class="btn btn-fill btn-info btn-sm">View All Variations</button>
          </div>
        </div>
      </div>
      <div v-for="retailer in retailersTable" class="col-lg-3" :key="retailer.key">
        <div class="card" style="padding-top:10px;">
          <div class="text-center">
            <h3>{{retailer.name}}</h3>
          </div>
          <div class="text-center" style="height: 140px; display: flex; align-items: center;">
            <div class="img-container">
              <img v-if="retailer.logoUrl" :src="retailer.logoUrl" :alt="retailer.name">
              <span v-if="!retailer.logoUrl">{NO RETAILER LOGO}</span>
            </div>
          </div>
          <hr>
          <div v-if="retailer.isPermanent" class="text-center" style="height: 40px;">
            Permanent Retailer
          </div>
          <div v-if="!retailer.isPermanent" class="text-center" style="height: 40px;">
            <button type="button" v-if="!retailer.deleting" @click.prevent="deleteRetailer(retailer)" class="btn btn-fill btn-danger btn-sm">Delete</button>
            <button type="button" v-if="retailer.deleting" class="btn btn-danger btn-sm" disabled="disabled">
              <span class="btn-label">
                <i class="fa fa-circle-o-notch fa-spin"></i>
              </span>
              Deleting...
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import Vue from 'vue'
  import store from '@/store'
  import swal from 'sweetalert2'
  import {mapFields} from 'vee-validate'
  import {Table, TableColumn} from 'element-ui'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import db from '@/components/firebase/init'
  import firebase from 'firebase'
  import PProgress from 'src/components/UIComponents/Progress.vue'
  import { toolboxMixin } from '@/components/mixins/toolboxMixin'
  // import firebase from 'firebase'
  // var storageRef = firebase.storage().ref()
  Vue.use(Table)
  Vue.use(TableColumn)
  export default{
    components: {
      PSwitch,
      PProgress
    },
    mixins: [toolboxMixin],
    props: ['accountData'],
    computed: {
      ...mapFields(['logoUrl',
        'name']),
      maxReached () {
        console.log('accountData', this.accountData)
        let reached = this.accountData.authDetails.account.data.planUsageQtyCustomRetailers >= this.accountData.authDetails.account.data.planConstraints.maxCustomRetailers
        return reached
      },
      retailerSlotsRemaining () {
        let maxRetailers = this.accountData.authDetails.account.data.planConstraints.maxCustomRetailers
        let qtyRetailers = this.accountData.authDetails.account.data.planUsageQtyCustomRetailers
        let remaining = maxRetailers - qtyRetailers
        remaining = Math.max(remaining, 0)
        console.log('accountData, maxRetailers, qtyRetailers, remaining', this.accountData, maxRetailers, qtyRetailers, remaining)
        return remaining
      }
    },
    data () {
      return {
        user: {
          email: '',
          token: ''
        },
        retailerIdIndexMap: new Map(),
        newRetailer: {
          logoUrl: '',
          name: ''
        },
        imageFile: '',
        uploadProgress: 0,
        loading: false,
        modelValidations: {
          logoUrl: {
            required: true,
            url: true
          },
          name: {
            required: true,
            max: 30
          }
        },
        retailersTable: [],
        selects: {
          simple: '',
          multiple: 'ARS'
        },
        showingAmazon: false
      }
    },
    methods: {
      init () {
        this.getCurrentUser().then(result => {
          this.user = result
          console.log('got user from store')
          console.log(this.user)
          this.getRetailers()
        })
      },
      selectFile () {
        this.imageFile = this.$refs.imageFile.files[0]
        this.uploadFile()
      },
      uploadFile () {
        this.loading = true

        var storageRef = firebase.storage().ref()
        var filename = this.$uuid.v4() + '.' + this.imageFile.name.split('.').pop()
        var uploadTask = storageRef.child(`accounts/${this.user.accountId}/retailers/${filename}`).put(this.imageFile)

        // Listen for state changes, errors, and completion of the upload.
        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
          snapshot => {
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            this.uploadProgress = progress
            console.log('Upload is ' + progress + '% done')
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED: // or 'paused'
                console.log('Upload is paused')
                break
              case firebase.storage.TaskState.RUNNING: // or 'running'
                console.log('Upload is running')
                break
            }
          }, error => {
            // A full list of error codes is available at
            // https://firebase.google.com/docs/storage/web/handle-errors
            swal.fire({
              title: 'Error Uploading Image',
              text: 'Please try a different image and contact support if the problem persists',
              type: 'error',
              confirmButtonClass: 'btn btn-info btn-fill',
              buttonsStyling: false
            }).then(() => {
              this.loading = false
            })
            switch (error.code) {
              case 'storage/unauthorized':
                // User doesn't have permission to access the object
                break

              case 'storage/canceled':
                // User canceled the upload
                break

              case 'storage/unknown':
                // Unknown error occurred, inspect error.serverResponse
                break
            }
          }, () => {
            // Upload completed successfully, now we can get the download URL
            uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
              console.log('File available at', downloadURL)
              this.newRetailer.logoUrl = downloadURL
              this.loading = false
            })
          })
      },
      getRetailers () {
        this.showingAmazon = false
        this.retailersTable = []
        this.retailerIdIndexMap = new Map()

        let ref = db.collection(`accounts/${this.user.accountId}/retailers`)
        ref.onSnapshot(snapshot => {
          snapshot.docChanges().forEach(async change => {
            if (change.type === 'added') {
              let doc = change.doc
              let data = {
                id: doc.id,
                name: doc.data().name,
                logoUrl: await this.retailerImgUrl(doc.id, doc.data(), '140x140'),
                key: this.$uuid.v4(),
                isPermanent: doc.data().isPermanent
              }
              this.retailersTable.push(data)
              this.retailerIdIndexMap.set(doc.id, this.retailersTable.length - 1)
            }
          })
        })
      },
      getGloAmazonRetailers () {
        this.showingAmazon = true
        this.retailersTable = []
        this.retailerIdIndexMap = new Map()

        let gloRef = db.collection('globalRetailers')
        gloRef.onSnapshot(snapshot => {
          snapshot.docChanges().forEach(async change => {
            if (change.type === 'added') {
              let doc = change.doc
              let data = {
                id: doc.id,
                name: doc.data().name,
                logoUrl: await this.retailerImgUrl(doc.id, doc.data(), '140x140'),
                key: this.$uuid.v4(),
                isPermanent: true
              }
              this.retailersTable.push(data)
              this.retailerIdIndexMap.set(doc.id, this.retailersTable.length - 1)
            }
          })
        })
      },
      addRetailer () {
        let retailer = {
          name: this.newRetailer.name,
          logoUrl: this.newRetailer.logoUrl,
          isPermanent: false
        }
        db.collection(`accounts/${this.user.accountId}/retailers`).add(retailer).then(response => {
          this.loading = false
        })
        .catch(err => {
          swal.fire({
            title: 'Error',
            text: err,
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          })
          this.loading = false
        })
      },
      validateAddRetailer () {
        this.loading = true
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.addRetailer()
          } else {
            this.loading = false
          }
        })
      },
      async deleteRetailer (retailer) {
        try {
          let retailerId = retailer.id
          retailer.deleting = true
          retailer.key = this.$uuid.v4()
          let data = {}
          data.userToken = await firebase.auth().currentUser.getIdToken()
          data.accountId = this.user.accountId
          data.retailerId = retailerId
          let accountDeleteRetailer = firebase.functions().httpsCallable('accountDeleteRetailer')
          let result = await accountDeleteRetailer(data)
          retailer.deleting = false
          retailer.key = this.$uuid.v4()
          this.showNotify(`Retailer ${retailer.name} deleted.`, 'success', 'Success')
          this.retailersTable.splice(this.retailerIdIndexMap.get(retailerId), 1)
        } catch (err) {
          retailer.deleting = false
          retailer.key = this.$uuid.v4()
          swal.fire({
            title: 'Error',
            text: err,
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          })
        }
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      handleLike (index, row) {
        alert(`Your clicked on Like button`)
      },
      handleEdit (index, row) {
        alert(`Your want to edit ${row.name}`)
      },
      handleDelete (index, row) {
        alert(`Your want to delete ${row.name}`)
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.init()
      })
    }
  }
</script>
<style>
.img-container {
  max-width: 140px;
  max-height: 140px;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Dashboard/Retailers.vue